export default __webpack_public_path__ + "static/media/ETEF-16-17.f7969416.pdf";